import ProjectTemplate from '../../components/common/ProjectTemplate';

const AccessoryListPage = () => {
    return (
        <ProjectTemplate>
            Accessory List Page
            {/* 프로젝트에 포함된 Accessory List를 보여준다. 하지만 몇개 되지 않아 따로 보여줄 만한 내용인지 고민이다.
            프로젝트에 관계없이 모든 Tripper, Shuttle, Scraper, etc. 를 보여준다. 
            추가할 때는 기존의 유사한 설비를 선택할 수 있도록 하고 '프로젝트'와 '설치되는 컨베이어'를 선택하도록 한다.
            해당하는 설비를 선택하고 기존 자료 가져오기를 수행한다. */}

        </ProjectTemplate>
    );
};

export default AccessoryListPage;
